<template>
  <el-row type="flex" justify="center">
    <el-col :span="20">
      <div class="ad-banner top">
        <ins class="adsbygoogle" style="display:block;min-width:400px;max-width:970px;width:100%;height:90px;margin: auto;" data-ad-client="ca-pub-5507837965607182" data-ad-slot="4020346692" data-full-width-responsive="true"></ins>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ad-top',
  mounted() {
    let adsbygoogle = window.adsbygoogle;
    if (!adsbygoogle) {
      adsbygoogle = [];
    }
    adsbygoogle.push({});
    window.adsbygoogle = adsbygoogle;
  }
}
</script>

<style scoped>
.ad-banner {
  line-height: 7em;
  max-height: 7em;
  text-align: center;
  vertical-align: middle;
}
.ad-banner.top {
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 1em;
}
</style>